<form *ngIf="form" [formGroup]="form">

    <div class="mb-3 p-3 rounded border bg-white shadow-sm">

        <h5 class="mb-1">Select Your Available Times</h5>

        <div id="time-timezone-text" class="text-danger mb-3" *ngIf="isThailandFocus">
            Timezone : {{now | date:'zzz': timezone}} (Bangkok time). The event will be conducted in physical event, unless selected virtual
        </div>

        <div *ngFor="let slot of slotsFormArray.controls; let i = index" class="slot-divider" >
            <div class="mb-3">
                <strong id="time-slot-date-{{i}}">
                    {{slot.value.slotDate | date:'MMM dd, yyyy': eventType === eventTypeEnum.THAILANDFOCUS ? 'UTC +7': null}}
                </strong>
            </div>

            <label class="mb-3">
                <input type="checkbox"
                        class="form-check-input-{{i}} form-checkbox"
                        [checked]="isAllSelected(slot)"
                        [disabled]="isClosedRegis"
                        (change)="toggleSelectAll(slot, $event.target.checked)">
                <span class="form-check-label">Select All</span>
            </label>

            <div class="time-slot-container">
                <div *ngFor="let sp of ((slot|formGroup).controls.slotPeriods|formArray).controls; let j = index;">

                    <div [ngClass]="(sp.value.isAvailable)? 'time-box-item is-check':'time-box-item'"
                        (click)="changeIsAvalable(sp.controls.isAvailable)">
                        <span id="time-slot-period-text-{{i}}-{{j}}">
                            {{sp.value.startTime | date:'HH:mm': eventType === eventTypeEnum.THAILANDFOCUS ? 'UTC +7': null}}
                            - {{sp.value.endTime | date:'HH:mm': eventType === eventTypeEnum.THAILANDFOCUS ? 'UTC +7': null}}
                        </span>
                    </div>
                </div>

            </div>
        </div>

    </div>
    
    <div class="d-flex justify-content-end">                    
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isClosedRegis || form.invalid">Save</button>
    </div>

</form>